import { Type, type Static } from '@sinclair/typebox';
import { createSchema } from '../../util/schema';

export const HealthCheckResult = Type.Object({
  name: Type.String(),
  ok: Type.Boolean(),
  detail: Type.Optional(Type.String()),
});
export type HealthCheckResult = Static<typeof HealthCheckResult>;
export const healthCheckResultSchema = createSchema(HealthCheckResult);

export const HealthResponse = Type.Object(
  {
    ok: Type.Boolean(),
    stage: Type.Optional(
      Type.String({
        pattern: '^(dev-[a-z0-9-]+|pr-\\d+|qa|stg|uat|prod)$',
      }),
    ),
    checks: Type.Array(HealthCheckResult),
  },
  { $id: 'HealthResponse' },
);
export type HealthResponse = Static<typeof HealthResponse>;
export const healthResponseSchema = createSchema(HealthResponse);
